import "../agradecimento/agradecimento.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";

const AgradecimentoSelecao = () => {
  return (
    <div className="container-agradecimento">
      <div className="barra-header"></div>
      <img src={sbfLogo} alt="SBF" className="logo-agradecimento" />
      <div
        style={{
          width: "60%",
          marginTop: "25px",
          fontSize: "19px",
          textAlign: "center",
        }}
      >
        <p>
          <b>Seleção de Participantes Concluída!</b>
          <br />
          <br />
          Sua seleção de participantes foi salva com sucesso.
          <br />
          <br />
          Agradecemos por dedicar seu tempo para organizar suas preferências de networking.
          <br />
          <br />
          Nossa equipe irá processar suas escolhas e você receberá informações sobre os próximos passos em breve.
          <br />
          <br />
          Em caso de dúvidas, entre em contato conosco pelo e-mail:{" "}
          <b>sbf@informa.com</b>
        </p>
      </div>
    </div>
  );
};

export default AgradecimentoSelecao; 